(function () {
  'use strict';

  // ─── BUILD VARIANT → MEDIA GROUP MAP DYNAMICALLY ─────────────────────────────
  // Uses Shopify's product JSON (available on all product pages via /products/handle.js)
  // Groups images by position: all images between one variant's assigned image
  // and the next variant's assigned image belong to that variant.

  function buildVariantMediaMap(product) {
    const map = {};

    // Collect all media IDs in their display order
    const allMediaIds = product.media.map(m => String(m.id));

    // Collect all variant-assigned media IDs and their positions
    const variantAssignments = [];
    product.variants.forEach(variant => {
      if (variant.featured_media) {
        const mediaId = String(variant.featured_media.id);
        const position = allMediaIds.indexOf(mediaId);
        if (position !== -1) {
          variantAssignments.push({
            variantId: String(variant.id),
            mediaId,
            position
          });
        }
      }
    });

    // Sort assignments by their position in the media array
    variantAssignments.sort((a, b) => a.position - b.position);

    // For each variant, collect its assigned image + all images up to
    // (but not including) the next variant's assigned image
    variantAssignments.forEach((assignment, index) => {
      const start = assignment.position;
      const end = index + 1 < variantAssignments.length
        ? variantAssignments[index + 1].position
        : allMediaIds.length;

      map[assignment.variantId] = allMediaIds.slice(start, end);
    });

    // Any media before the first variant assignment — attach to first variant
    if (variantAssignments.length > 0) {
      const firstAssignment = variantAssignments[0];
      const leading = allMediaIds.slice(0, firstAssignment.position);
      if (leading.length) {
        map[firstAssignment.variantId] = [
          ...leading,
          ...map[firstAssignment.variantId]
        ];
      }
    }

    return map;
  }

  // ─── APPLY GALLERY FILTER ────────────────────────────────────────────────────

  function applyGalleryForVariant(variantId, variantMediaMap) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const mediaIds = variantMediaMap[String(variantId)];
    if (!mediaIds || !mediaIds.length) return;

    const allItems = Array.from(gallery.querySelectorAll('[data-media-id]'));
    if (!allItems.length) return;

    const mediaIdSet = new Set(mediaIds);
    const parent = allItems[0].parentNode;

    // Show/hide
    allItems.forEach(item => {
      const id = String(item.dataset.mediaId);
      if (mediaIdSet.has(id)) {
        item.style.display = '';
        item.removeAttribute('hidden');
      } else {
        item.style.display = 'none';
        item.setAttribute('hidden', '');
      }
    });

    // Reorder in DOM so variant's images appear first
    mediaIds.forEach(id => {
      const el = gallery.querySelector(`[data-media-id="${id}"]`);
      if (el) parent.appendChild(el);
    });

    // Set first image as active
    const firstId = mediaIds[0];
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(firstId, true);
    } else {
      const thumb = gallery.querySelector(
        `[data-media-id="${firstId}"] button, [data-media-id="${firstId}"] a`
      );
      if (thumb) thumb.click();
    }
  }

  // ─── INIT ────────────────────────────────────────────────────────────────────

  function init() {
    // Shopify exposes product JSON via a script tag on every product page
    // window.ShopifyAnalytics.meta.product is available in most themes,
    // but the most reliable source is the product JSON script tag injected by Shopify
    const productJson = document.getElementById('ProductJson')
      || document.querySelector('script[data-product-json]')
      || document.querySelector('[id*="product-json"]');

    let product = null;

    if (productJson) {
      try { product = JSON.parse(productJson.textContent); } catch (e) {}
    }

    // Fallback: use window.meta if available (ShopifyAnalytics)
    if (!product && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      product = window.ShopifyAnalytics.meta.product;
    }

    // Fallback: fetch from product JSON endpoint
    if (!product) {
      const canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) return;
      const handle = canonical.href.split('/products/')[1];
      if (!handle) return;

      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(data => initWithProduct(data))
        .catch(() => {});
      return;
    }

    initWithProduct(product);
  }

  function initWithProduct(product) {
    if (!product || !product.variants || !product.media) return;

    const variantMediaMap = buildVariantMediaMap(product);

    // Apply on load for the pre-selected variant
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );
    if (variantInput && variantInput.value) {
      applyGalleryForVariant(variantInput.value, variantMediaMap);
    }

    // Apply on variant change — Flow fires 'variant:change' on document
    document.addEventListener('variant:change', function (event) {
      const variant = event.detail && (event.detail.variant || event.detail);
      if (variant && variant.id) {
        applyGalleryForVariant(variant.id, variantMediaMap);
      }
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
